import { Component, signal } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import { combineLatest } from 'rxjs';
import { CpReportsScaleService } from '../cp-reports-month-viewer/cp-reports-scale-selector/cp-reports-scale.service';

@Component({
  selector: 'app-cp-reports-explanatory-factors',
  templateUrl: './cp-reports-explanatory-factors.component.html',
  styleUrls: ['./cp-reports-explanatory-factors.component.scss']
})
export class CpReportsExplanationFactoryComponent {

  isInfoOpen = signal(false);

  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  viewModel$ = combineLatest({
    report: this.report$,
    scale: this.cpReportsScaleService.scale$,
  });

  EnumScales = EnumScales;

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private cpReportsScaleService: CpReportsScaleService,
  ) { }

  hasExplanatoryFactors(report: EnergyReport) {
    return report.average_external_temperature || report.average_internal_temperature;
  }

  setInfo() {
    this.isInfoOpen.update(isOpen => !isOpen);
  }

}
